

















import { Vue, Component } from 'vue-property-decorator'

const BATCH_AMOUNT = 100

interface SerialInput {
	id: string
	SKU: string
}

import { $db } from '@/services/Db'

@Component
export default class BulkWhitelist extends Vue {

	serials = ''
	sku = ''

	uploading = false
	progress = 0
	total = 0
	error = ''

	get submitDisabled() {
		return !this.serials.trim() || !this.sku.trim()
	}

	async upload() {
		this.error = ''
		const SKU = this.sku.trim()
		const serials: SerialInput[] = this.serials.split('\n').map(s => ({ id: s.trim(), SKU }))
		const batches: SerialInput[][] = []
		let batch: SerialInput[] = []
		this.total = serials.length
		this.progress = 0

		while(serials.length) {
			batch.push(serials.shift()!)
			if(batch.length === BATCH_AMOUNT) {
				batches.push(batch)
				batch = []
			}
		}
		if(batch.length) {
			batches.push(batch)
		}

		this.uploading = true

		while(batches.length) {
			batch = batches.shift()!
			try {
				await $db.query(`mutation SerialUpload($serials: [SerialInput!]!) {
					serialsBulkWhitelist(serials: $serials)
				}`, { serials: batch })
				this.progress += batch.length
			} catch(err) {
				this.error = err.message
				break
			}
		}

		if(!this.error) {
			this.serials = ''
			this.sku = ''
		}

		this.uploading = false

	}

}
